import { useEffect, useRef, useState } from 'react';

export function useViewportWidth(delay = 120) {
  const getWidth = () => {
    if (typeof window === 'undefined') return 0;
    return window.innerWidth;
  };

  const [width, setWidth] = useState<number>(getWidth);

  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const update = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        setWidth(getWidth());
      }, delay);
    };

    update();

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.visualViewport?.addEventListener('resize', update);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      window.visualViewport?.removeEventListener('resize', update);
    };
  }, [delay]);

  return width;
}
